<template>
    <div :key="key">
        <div v-if="deadline.menu.can_edit && deadline.menu.can_edit_date">
            <b-input
                ref="date"
                v-model="form.deadline_date"
                size="sm"
                :class="reactiveClass"
                @change="saveDeadline"
            />
        </div>
        <div v-else>
            {{ form.deadline_date }}
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler'

export default {
    name: 'DeadlineDateForm',

    mixins: [TableFormHandler],

    props: {
        deadline: {},
    },

    methods: {
        async saveDeadline() {
            try {
                await axios.put(
                    `/clientDeadlines/${this.deadline.id}/date`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.deadline_date = this.$moment(
                this.deadline.deadline_date
            ).format('D/M/Y')
        },

        setInitialKey() {
            this.key = `date${this.deadline.id}`
        },

        unFocus() {
            this.$refs.date.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
